import {Component, Input, OnInit} from '@angular/core';
import {Size} from '../../models/size';

@Component({
  selector: 'awair-plus-icon',
  templateUrl: './plus-icon.component.html',
  styleUrls: ['./plus-icon.component.scss']
})
export class PlusIconComponent implements OnInit {

  private _color: string = '#FFFFFF';
  get color() {
    return this._color;
  }
  @Input()
  set color(value: string) {
    this._color = value;
  }

  get size(): Size {
    if (this._size != null) {
      return this._size;
    }
  }
  @Input()
  set size(value: Size) {
    if (value != null) {
      this._size = {...value};
    }
  }
  private _size: Size = {
    width: 15,
    height: 15
  };

  constructor() {
  }

  ngOnInit() {
  }
}
